module.exports = __webpack_public_path__ + "static/Flavor-German-Amarillo-T45-VA18000298-677b7569ca94a2c5d3eda1ef9d25fa13.pdf";